module.exports = __webpack_public_path__ + "static/media/Settings.64c51952.svg";